import configurationClient from '@/axiosClients/configurationClient'
import {errorHttpMessage} from "@/utils/errorDecodeUtil"

export const saveUser = async ({commit}, formData) => {

    try {
        const {data: result} = await configurationClient.post('/profile/edit', formData)
        const {message, error} = result.result
        
        if (!error) {
            // Actualizar el usuario en sessionStorage con force_password_change = false
            const user = JSON.parse(sessionStorage.getItem('user'))
            if (user && user.force_password_change) {
                user.force_password_change = false
                sessionStorage.setItem('user', JSON.stringify(user))
                // Actualizar el store de auth
                commit('auth/updateUser', user, {root: true})
            }
        }
        
        return {message, error}
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response.data, error: true}
    }

}

export const findUserByToken = async ({commit}, userId) => {
    try {
        const {data: result} = await configurationClient.get(`/profile`)
        const {data, message, error} = result.result
        return {data, message, error}
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, data: ex, error: true}
    }
}

export const deleteImage = async ({commit}, type) => {
    try {
        const {data: result} = await configurationClient.delete('/profile/' + type)
        const {data, message, error} = result.result
        return {data, message, error}
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, data: ex, error: true}
    }
}

export const getPractitionerTitles = async ({commit}) => {

    try {
        const {data: result} = await configurationClient.get('/catalog/practitioner-titles')
        const {data, message, error} = result.result
        return {data, message, error}
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response.data, error: true}
    }

}



